import React, { FC, useState } from "react";
import styled from "styled-components";
import { Link } from "gatsby";

import { mediaQuery } from "src/themes/breakpoints";
import { colors } from "src/themes/colors";
import Burger from "./Burger";

const StyledNavigation = styled.nav`
  align-items: center;
  display: grid;
  grid-column-gap: 42px;
  grid-template-columns: repeat(3, auto);
  justify-content: space-between;

  ${mediaQuery("md", "max")} {
    align-items: flex-start;
    background-color: ${colors.blue};
    display: flex;
    flex-direction: column;
    height: 100vh;
    justify-content: flex-start;
    padding: 100px 20px;
    position: absolute;
    right: 0;
    top: 0;
    transform: ${(props) =>
      props.$open ? "translateX(0)" : "translateX(100%)"};
    transition: transform 0.3s ease-in-out;
    width: 260px;

    & > * {
      border-top: 1px solid ${colors.grey100};
      display: block;
      padding: 20px 0;
      width: 100%;
    }

    & > :last-child {
      border-bottom: 1px solid ${colors.grey100};
    }
  }
`;

const StyledLink = styled(Link)`
  color: ${(props) => (props.$white ? `${colors.blue}` : `${colors.grey100}`)};
  font-weight: 700;
  position: relative;

  ${mediaQuery("md", "max")} {
    color: ${colors.grey100};
  }

  &:after {
    background: none repeat scroll 0 0 transparent;
    background-color: ${(props) =>
      props.$white ? `${colors.blue}` : `${colors.grey100}`};
    bottom: 0;
    content: "";
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    transition: width 0.3s ease 0s, left 0.3s ease 0s;
    width: 0;
  }

  &:hover:after {
    width: 100%;
  }
`;

interface NavigationProps {
  isWhite: boolean;
}

const Navigation: FC<NavigationProps> = ({ isWhite }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <StyledNavigation $open={open} role="primary">
        <StyledLink
          $white={isWhite}
          to="/about-us"
          onClick={() => setOpen(false)}
        >
          Über Uns
        </StyledLink>
        <StyledLink $white={isWhite} to="/news" onClick={() => setOpen(false)}>
          News
        </StyledLink>
        <StyledLink
          $white={isWhite}
          to="/contacts"
          onClick={() => setOpen(false)}
        >
          Kontakt
        </StyledLink>
      </StyledNavigation>
      <Burger isOpen={open} setIsOpen={setOpen} isDark={isWhite || open} />
    </>
  );
};

export default Navigation;
